import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AddHorario from "./AddHorario";
import { apiHorariosService } from "services/apiHorariosService";

const DetalleHorario = () => {
  const { id } = useParams();

  const [horario, setHorario] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await apiHorariosService.getById(id);
      setHorario(response);
    };

    fetchData();
    return () => {
      setHorario(null);
    };
  }, [id]);

  return (
    <>{horario !== null ? <AddHorario horario={horario}></AddHorario> : ""}</>
  );
};

export default DetalleHorario;
